export const PENDING = 0
export const ACTIVE = 1
export const INACTIVE = 2
